// Updated: 2026-08-04 18:48:00 CDT
// Purpose: Convert OpenF5 health responses into a simple public availability state.

import type { Health } from "@/lib/ttsClient";

export type TtsAvailabilityStatus =
  | "checking"
  | "online"
  | "warming"
  | "offline";

export const classifyTtsHealth = (
  health: Health,
): Exclude<TtsAvailabilityStatus, "checking"> => {
  if (health.status !== "ok" || health.load_error) {
    return "offline";
  }

  if (health.model_loaded) {
    return "online";
  }

  if (health.model_loading) {
    return "warming";
  }

  return "offline";
};
